import React from 'react';
import Link from './Link';

export default {
  captainCanNotLeaveTeam:
    `Чтобы покинуть команду, необходимо передать права капитана другому игроку.`,

  couldNotAcceptInvite:
    `Не удалось подтвердить заявку. Возможно, в команде больше нет вакантных мест или команда участвует в матче.`,

  couldNotApproveRequest:
    `Не удалось подтвердить заявку. Возможно, игрок принял приглашение другой команды или участвует в матче.`,

  incorrectNickName:
    `<div>Ник-нейм введен неверно. Убедись, что он удовлетворяет следующим требованиям:
       <ul class='Avatar-NickNameAlert'>
         <li>— содержит от 4 до 51 символов</li>
         <li>— состоит не более чем из двух слов</li>
         <li>— может содержать только символы русского, английского языка и цифры</li>
         <li>— в одном слове может содержать символы только одного языка и цифры</li>
       </ul>
     </div>`,

  nickNameExists:
    `Команда с таким названием уже зарегистрирована.`,

  teamNameIsConstant:
    `Обрати внимание, что после нажатия кнопки "Cохранить" будет невозможно изменить название команды самостоятельно.`,

  teamHasActiveTournament:
    `Команда в данный момент участвует в турнире. В этот период состав команды должен оставаться неизменным. Попробуй позже.`,

  teamHasActiveTournamentAndRoleChangeFail:
    `<p>Невозможно изменить состав в данный момент.</p>
     <p>Возможно, сейчас команда участвует в матче.</p>`,

  teamFullCanNotInvite:
    `Команда набрана полностью, поэтому пригласить еще одного игрока не получится.`,

  approveCaptainRoleChange:
    `Уверен, что хочешь передать права капитана другому игроку? Отменить данное действие самостоятельно будет невозможно.`,

  approvePlayerKick:
    `Вы уверены, что хотите удалить игрока из команды. Операцию нельзя будет отменить.`,

  approveLeaveTeam:
    `Уверен, что хочешь покинуть команду? Отменить данное действие самостоятельно будет невозможно.`,

  authBeforeInvitingPlayer:
    `Авторизуйся, чтобы иметь возможность пригласить игрока в команду.`,

  authBeforeJoiningTeam:
    `Чтобы вступить в команду, необходимо авторизоваться и повторить попытку.`,

  authBeforeCreatingTeam:
    `Для создания команды необходимо авторизоваться`,

  createTeamBeforeInvite:
    `Чтобы пригласить игрока, необходимо сначала <Link name="teamsNew">создать команду</Link>.`,

  onlyCaptainCanInvite:
    `Только капитан команды может пригласить игрока.`,

  haveTeamAlready:
    `У тебя уже есть команда.`,

  leaveTeamBeforeCreatingTeam:
    `Чтобы создать новую команду, необходимо покинуть ту, в составе которой ты сейчас находишься.`,

  tournamentRegisterNeedAuth:
    `Авторизуйся, чтобы участвовать в турнире.`,

  tournamentRegisterNeedTeam:
    `Чтобы принять участие в турнире, необходимо вступить в существующую команду или создать свою.`,

  tournamentRegisterNeedToBeCaptain:
    `Только капитан может зарегистрировать команду.`,

  tournamentRegisterNeedMorePlayers:
    `Для регистрации в турнире в команде должно быть не менее 5 человек.`,

  tournamentRegisterSuccess:
    `Отлично, команда зарегистрирована. Не забудь подтвердить участие в турнире.`,

  tournamentRegisterApproveSuccess:
    `Прекрасно, участие подтверждено! Следи за новостями на странице турнира.`
};


// WEBPACK FOOTER //
// ./src/components/notices.js